export default function initCardsOffers() {
    const $cardsOffers = document.querySelector<HTMLElement>('.js-cards-offers');

    if ($cardsOffers) {
        new CardsOffer($cardsOffers);
    }
}

export class CardsOffer {
    $container: HTMLElement;
    $cards: NodeListOf<HTMLElement> | null;

    constructor($container: HTMLElement) {
        this.$container = $container;
        this.$cards = $container.querySelectorAll<HTMLInputElement>('.card');


        if (this.$cards) {
            this.$cards.forEach(card =>
                this.init(card))
        }
    }

    /**
     * gere l'effet de tilt des cartes
     * 
     * @param {HTMLElement} $card
     *
     * @return {void}
     */
    init($card: HTMLElement) {
        $card.addEventListener('mousemove', (event: MouseEvent) => {
            if ($card) {
                const cardWidth = $card.clientWidth;
                const cardHeight = $card.clientHeight;
                const cardBound = $card.getBoundingClientRect();
                const centerX = cardBound.left + cardWidth/2;
                const centerY = cardBound.top + cardHeight/2;

                const mouseX = event.clientX - centerX;
                const mouseY = event.clientY - centerY;

                const rotateX = 4*mouseY/(cardHeight/2);
                const rotateY = 4*mouseX/(cardWidth/2);

                $card.style.transform = `perspective(1000px) translateZ(20px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;

            }
        });

        $card.addEventListener('mouseleave', ()=>{
            if ($card) {
                $card.style.transform = `perspective(1000px) rotateX(0deg) rotateY(0deg)`
            }

        })
    }
}
